var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tabs),function(tab,i){return _c('ClassicTabButton',{key:i,attrs:{"tab-position":i,"tab":tab}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }